import './CollapsibleCell.e313183fba8e79024beccc830d719cf9.css';
export default {"collapsibleCell":"_collapsibleCell_3xe4n_1","open":"_open_3xe4n_1"};